import { type UiState } from 'instantsearch.js/es/types/ui-state'
import { useMemo } from 'react'
import { type InstantSearchNextRouting } from 'react-instantsearch-nextjs'

import {
  createUrl,
  productSearchAlgoliaIndexUiStateToRoute,
  type ProductSearchAlgoliaRouteState,
  productSearchAlgoliaRouteToIndexUiState,
  useProductSearchContext,
} from '../../../../product-search'

export const useStoryblokAlgoliaSearchRouting = (): InstantSearchNextRouting<
  UiState,
  ProductSearchAlgoliaRouteState
> => {
  const {
    productSearchConfig: { baseAlgoliaConfig, sortByIndexes },
  } = useProductSearchContext()

  const { productsAlgoliaIndex } = baseAlgoliaConfig

  return useMemo(
    () => ({
      router: {
        cleanUrlOnDispose: false,
        createURL: createUrl,
      },

      stateMapping: {
        routeToState(routeState): UiState {
          return {
            [productsAlgoliaIndex]: productSearchAlgoliaRouteToIndexUiState(
              routeState,
              {
                sortByIndexes: sortByIndexes.map((item) => item.value),
              },
            ),
          }
        },
        stateToRoute(uiState): ProductSearchAlgoliaRouteState {
          return productSearchAlgoliaIndexUiStateToRoute(uiState, {
            productsAlgoliaIndex,
          })
        },
      },
    }),
    [productsAlgoliaIndex, sortByIndexes],
  )
}
